"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BannerPreview = void 0;
const react_1 = __importDefault(require("react"));
const EventBandBanner_1 = require("../../base/layout/EventBandBanner");
const preventDefault = (e) => e.preventDefault();
/**
 * 관리자용 띠배너 미리보기 — 포털 실배너와 동일한 BandBannerView 를 문서 흐름(inline)으로 그린다.
 * mode 'pc' 는 목록 카드용(PC 1줄), 'both' 는 편집 화면용(PC + 모바일 390px).
 */
exports.BannerPreview = react_1.default.memo(({ banner, mode = 'both' }) => {
    const shown = {
        ...banner,
        title: banner.title.trim() || '제목을 입력하면 여기에 표시됩니다',
    };
    return (react_1.default.createElement("div", { className: "banner-preview" },
        react_1.default.createElement("div", { className: "banner-preview-block" },
            mode === 'both' && react_1.default.createElement("p", { className: "banner-preview-label" }, "PC \uBBF8\uB9AC\uBCF4\uAE30"),
            react_1.default.createElement("div", { className: "banner-preview-frame" },
                react_1.default.createElement(EventBandBanner_1.BandBannerView, { banner: shown, isMobile: false, inline: true, onClose: preventDefault }))),
        mode === 'both' && (react_1.default.createElement("div", { className: "banner-preview-block" },
            react_1.default.createElement("p", { className: "banner-preview-label" }, "\uBAA8\uBC14\uC77C \uBBF8\uB9AC\uBCF4\uAE30 (390px)"),
            react_1.default.createElement("div", { className: "banner-preview-frame mobile" },
                react_1.default.createElement(EventBandBanner_1.BandBannerView, { banner: shown, isMobile: true, inline: true, onClose: preventDefault }))))));
});
